export default from './create-post-handler';



// WEBPACK FOOTER //
// ./app/containers/create-post-handler/index.js